import { useId } from "react";

function RadioInput({ name, value, onChange, defaultValue, label }) {
  const accessAbleId = useId();

  return (
    <>
      <div className="flex items-center mb-[1rem]">
        <input
          type="radio"
          name={name}
          value={value}
          checked={value === defaultValue}
          id={accessAbleId}
          className={` w-[0.625rem] h-[0.625rem] ring-1 ring-offset-2 ring-[#E91F63] bg-white border-0 checked:bg-[#E91F63] mr-[0.875rem] checked:bg-none focus:outline-none  focus:ring-1 focus:ring-[#E91F63]`}
          onChange={(e) => onChange(e.target.value)}
        />
        <label htmlFor={accessAbleId} className="text-[1rem] text-[#0A101A]">
          {label}
        </label>
      </div>
    </>
  );
}

export default RadioInput;
